/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { SelectAutocomplete } from "components/haven-design/form/select";
import StructuredReasons from "components/structured-reasons";
import { Input } from "components/haven-design/form/inputs";
import { QueryInterestProfile_interest as InterestType } from "types/gql-types";
import styles from "./batchActions.module.css";

export type ChangeStatusStateValues = {
  actionDate: string | null;
  reason: string;
  status: string;
  unitNumber: string | null;
}

type Props = {
  interest: InterestType;
  onChange: (item: Partial<ChangeStatusStateValues>) => void;
  isShowing: boolean;
  state: ChangeStatusStateValues;
  fieldErrors: { status: string; reason: string };
}
const ChangeStatusForm: React.FC<Props> = ({
  interest,
  onChange,
  isShowing,
  state,
  fieldErrors,
}) => {
  const statusOptions = (interest?.interestList?.property?.stages || [])
    .filter(({ enabled }) => enabled);

  const [reasonIsShowing, setReasonIsShowing] = useState(false);
  const [status, setStatus] = useState<string | undefined>();
  const [reason, setReason] = useState<string>("");

  return (
    <div className={isShowing ? "" : styles.hideView} style={{ width: "100%" }}>
      <Grid size={{ xs: 12 }}>
        <div className={styles.actionViewLabel} style={{ whiteSpace: "nowrap" }}>
        Change Status from &quot;{interest.status.name}&quot;
        </div>

        <SelectAutocomplete
          margin="dense"
          label="Select Outcome *"
          options={statusOptions as any[]}
          getOptionDisabled={(option: any) => option.name === interest.status.name}
          getOptionLabel={(option: any) => option.name}
          isOptionEqualToValue={(option: any, value: any) => option.name === value.name}
          value={status}
          error={Boolean(fieldErrors.status)}
          helperText={fieldErrors.status}
          onChange={(_, newStatus: any) => {
            if (!newStatus) return;

            setStatus(newStatus.name);
            setReasonIsShowing(true);
            onChange({
              status: newStatus.name,
              reason,
              actionDate: newStatus.name === "Moved In" ? new Date().toISOString() : null,
            });
          }} />

        {status === "Moved In" && (
          <div>
            <DatePicker
              slotProps={{
                textField: {
                  style: { minWidth: "15em" },
                  margin: "dense",
                  name: "actionAt",
                  autoComplete: "off",
                  variant: "outlined",
                  label: "Move In Date",
                },
                inputAdornment: { position: "end" },
              }}
              format="MM/dd/yyyy"
              value={state.actionDate ? new Date(state.actionDate) : null}
              onChange={date => onChange({ actionDate: date?.toISOString() || null })}
            />

            <Input
              name="unitNumber"
              label="Unit Number"
              onChange={({ target: { value } }) => onChange({ unitNumber: value })}
            />
          </div>
        )}

        {reasonIsShowing && status !== "Moved In" && (
          <div className={styles.marginTop}>
            <p>Changing the status to <b>{status}</b> requires a reason for auditing purposes.</p>

            {status === "Removed" ? (
              <StructuredReasons
                label="Removal Reason*"
                error={Boolean(fieldErrors.reason)}
                helperText={fieldErrors.reason}
                onChange={(message) => {
                  setReason(message);
                  onChange({ status, reason: message, actionDate: new Date().toISOString() });
                }}
              />
            ) : (
              <div>
                <Input
                  name="reason"
                  label="Reason"
                  multiline
                  required
                  error={Boolean(fieldErrors.reason)}
                  helperText={fieldErrors.reason}
                  onChange={({ target: { value: message } }) => {
                    setReason(message);
                    onChange({ status, reason: message, actionDate: new Date().toISOString() });
                  }}
                  value={reason}
                />
              </div>
            )}
          </div>
        )}
      </Grid>
    </div>
  );
};

export default ChangeStatusForm;
